import { plainToClass } from 'class-transformer';
import { ClassType } from 'class-transformer/ClassTransformer';
import * as _ from 'lodash';

/**
 * A utility for copying objects
 */
export class ObjectCopyUtil {
  // ********************
  // Static methods
  // ********************

  /**
   * Perform a default (deep) copy of the object
   * @param objectToCopy - The object to copy
   * @returns The copied object
   */
  static copy<T>(objectToCopy: T): T {
    return ObjectCopyUtil.deepCopy(objectToCopy);
  }

  /**
   * Perform a deep copy of the object
   * @param objectToCopy - The object to copy
   * @returns The copied object
   */
  static deepCopy<T>(objectToCopy: T): T {
    const cloneObj = _.cloneDeep(objectToCopy);
    return cloneObj;
  }

  /**
   * Perform a shallow copy of the object
   * @param objectToCopy - The object to copy
   * @returns The copied object
   */
  static shallowCopy(objectToCopy: any): any {
    return { ...objectToCopy };
  }

  /**
   * Perform a typed of the object. Copy the object and then apply the properties of the passed class.
   * @param objectToCopy - The object to copy
   * @param type - The prototype whose methods will be copied
   * @returns The copied object
   */
  static typedCopy<T>(objectToCopy: any, type: ClassType<T>): T {
    let cloneObj = this.deepCopy(objectToCopy);
    cloneObj = plainToClass(type, cloneObj);
    return cloneObj;
  }
}
